<template>
<b-row class="text-center">
    <div class="form-group col-lg-12 col-sm-12">
        <div class="input-group" v-if="!loading">
            <span class="input-group-btn" v-if="this.canAA == 'l1Ll0O0ll1L'">
                <router-link v-if="this.$can('account','create')" :to="{name: 'Add Account'}" class="btn btn-primary">Add +</router-link>
            </span>
            <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" placeholder="Name">
            <span class="input-group-btn">
                <button type="button" class="btn btn-primary" @click.prevent="doFilter">Search</button>
                <button type="button" class="btn btn-primary" @click.prevent="resetFilter">Clear</button>
            </span>
        </div>
    </div>
</b-row>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            canAA: '0',
            filterText: '',
        }
    },
    methods: {
        doFilter() {
            this.$events.fire('filter-set', this.filterText)
        },
        resetFilter() {
            this.filterText = ''
            this.$events.fire('filter-reset')
        },
        newAccount() {
            console.log('Message #: 12890')
        },
    },

    created() {
        this.loading = true;
        let uri = `/api/users/L1`;
        axios.get(uri).then((response) => {
            this.canAA = response.data.data.L1;
            this.loading = false;

        });
    },

}
</script>
